import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import alertService from '../services/alertService';
import detectionService from '../services/detectionService';

export default function RecentAlerts({ onRecentCount }) {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!window.matchMedia('(min-width: 1024px)').matches) return;
      const results = await Promise.allSettled([detectionService.getEvents({ limit: 20 }), alertService.getPowerEvents()]);
      if (cancelled) return;
      const detections = results[0].status === 'fulfilled' ? results[0].value || [] : [];
      const power = results[1].status === 'fulfilled' ? results[1].value || [] : [];
      const merged = [
        ...detections.map((e) => ({ key: `d-${e.id}`, id: e.id, title: e.type || 'Detection', detail: e.stream_id, time: e.detected_at })),
        ...power.map((e) => ({ key: `p-${e.ID || e.id}`, title: e.Type || e.type || 'Power event', detail: 'Inverter', time: e.StartedAt || e.startedAt })),
      ].sort((a, b) => new Date(b.time) - new Date(a.time));
      setEvents(merged);
      onRecentCount?.(merged.filter((e) => Date.now() - new Date(e.time).getTime() < 86400000).length);
      setError(results.some((r) => r.status === 'rejected') ? 'Some alerts could not be loaded' : '');
      setLoading(false);
    };
    load();
    const timer = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(timer); };
  }, [onRecentCount]);
  return <section className="desktop-recent-alerts">
    <header><strong>Recent alerts</strong><button onClick={() => navigate('?tab=alerts')}>View all</button></header>
    {loading && <p>Loading alerts…</p>}
    {error && <p role="status">{error}</p>}
    {!loading && !error && !events.length && <p>No recent alerts</p>}
    {events.slice(0, 3).map((e) => <button className="desktop-alert-row" key={e.key} onClick={() => navigate(`?tab=alerts${e.id ? `&eventId=${encodeURIComponent(e.id)}` : ''}`)}>
      <span className="desktop-alert-icon">{e.id ? '◉' : 'ϟ'}</span><span><strong>{e.title.replaceAll('_', ' ')}</strong><small>{e.detail}</small></span>
      <time>{e.time ? new Date(e.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '—'}</time>
    </button>)}
  </section>;
}
